import { config } from 'src/config';

import type { WebViewScope } from '../constants/WebViewScope';

const isDevelopment = () =>
  !config.NODE_ENV || ['development', 'local'].includes(config.NODE_ENV);

const isStaging = () => window.location.host.includes('staging');

const isTest = () => config.NODE_ENV === 'test';

const isCi = () => config.CI;

const isProduction = () => config.NODE_ENV === 'production';

const isServer = () => typeof window === 'undefined';

const isBrowser = () => !isServer();

const isMobileApp = (scope?: WebViewScope) => {
  // if server, exit early as we're not in a browser environment
  if (isServer()) {
    return false;
  }

  const isRNWebView = Boolean(window.ReactNativeWebView);
  // if no scope is provided, return if it's a webview
  if (!scope || !isRNWebView) {
    return isRNWebView;
  }

  return window.HOVERApp?.appReferrer === scope;
};

const isInIframe = () => {
  if (isServer()) return false;
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const hasWebViewChannels = () =>
  isMobileApp() && window.HOVERApp?.channels !== undefined;

const hasNativeShare = () => !!navigator && !!navigator.share;

export {
  isBrowser,
  isDevelopment,
  isStaging,
  isTest,
  isCi,
  isProduction,
  isServer,
  isMobileApp,
  isInIframe,
  hasWebViewChannels,
  hasNativeShare,
};
